import React, { useContext, useEffect } from "react";
import { useDrag } from "react-dnd";
import { iconNew } from "@teamrota/rota-design";

import { SHIFT_TYPES, DND_ITEM_TYPES } from "~/src/consts";
import { formatHours } from "~/src/containers/scheduler/utils";
import { FocusShiftContext } from "~/src/containers/provide-schedule/FocusShift";
import {
  StyledOpenShift,
  Div,
  StyledPredicted
} from "./open-shift-weekly-card.styles";

import { getCardProps } from "../../card-styles";

const { Moon, Sun } = iconNew;

const OpenShiftWeeklyCard = ({
  shifts,
  setSelectedDayIndex,
  dayIndex,
  lastDraggedShiftId,
  setLastDraggedShiftId
}) => {
  const { setFocusShift } = useContext(FocusShiftContext);

  if (shifts?.length > 1) {
    const dayShiftsLength = shifts.filter(
      shift => shift.type !== SHIFT_TYPES.NIGHT
    ).length;

    const nightShiftsLength = shifts.filter(
      shift => shift.type === SHIFT_TYPES.NIGHT
    ).length;

    const hasReservedBookingsInShifts = shifts.some(
      shift => (shift.reservedBookings?.totalResults || 0) > 0
    );

    return (
      <StyledOpenShift
        isMultipleShifts={true}
        {...getCardProps(shifts, false, undefined, hasReservedBookingsInShifts)}
        onClick={() => setSelectedDayIndex(dayIndex)}
      >
        <Div fontSize="14px" fontWeight="500" margin="5px 0">
          <Sun />
          <Div fontSize="14px" fontWeight="500" margin="0 0 0 5px">
            {`${dayShiftsLength} ${dayShiftsLength === 1 ? "shift" : "shifts"}`}
          </Div>
        </Div>
        <Div fontSize="14px" fontWeight="500" margin="5px 0">
          <Moon />
          <Div fontSize="14px" fontWeight="500" margin="0 0 0 5px">
            {" "}
            {`${nightShiftsLength} ${
              nightShiftsLength === 1 ? "shift" : "shifts"
            }`}
          </Div>
        </Div>
      </StyledOpenShift>
    );
  } else if (shifts?.length === 1) {
    const shift = shifts[0];

    const [{ draggedShift, isDragging }, dragRef] = useDrag(
      () => ({
        type: DND_ITEM_TYPES.OPEN_SHIFT,
        item: () => shift,
        canDrag: () => true,
        collect: monitor => ({
          isDragging: monitor.isDragging(),
          draggedShift: monitor.getItem()
        })
      }),
      [shift]
    );

    useEffect(() => {
      if (isDragging && draggedShift.id !== lastDraggedShiftId) {
        setLastDraggedShiftId(draggedShift?.id);
      }
    }, [isDragging]);

    return (
      <StyledOpenShift
        isMultipleShifts={false}
        {...getCardProps(
          shift,
          shift.hasCancelledBookings,
          undefined,
          (shift.reservedBookings?.totalResults || 0) > 0
        )}
        ref={dragRef}
        onClick={() => {
          setSelectedDayIndex(dayIndex);
          setFocusShift(shift);
        }}
      >
        <Div fontSize="14px" margin="5px 0">
          {shift.roleRate.roleName}
        </Div>
        <Div fontSize="14px" fontWeight="500" margin="5px 0">
          {formatHours(shift)}
        </Div>
        <Div fontSize="12px" margin="5px 0">
          {shift?.venue?.name} ({shift?.sourceAccount.accountName})
        </Div>
        <Div fontSize="14px" margin="5px 0">
          {!shift.isPredicted && (
            <>
              {(shift.bookings.totalResults || 0) +
                (shift.reservedBookings?.totalResults || 0)}
              /{shift.numberRequested}
            </>
          )}

          {shift.isPredicted && (
            <>
              {shift.numberRequested} <StyledPredicted />
            </>
          )}
        </Div>
      </StyledOpenShift>
    );
  }

  return null;
};

export default OpenShiftWeeklyCard;
